/**
 * Reminder Recurrence Type
 */
export enum ReminderRecurrenceType {
  /**
   * Once. Does not repeat.
   */
  Once = 'once',

  /**
   * Per minute.
   */
  PerMinute = 'per-minute',

  /**
   * Per hour.
   */
  Hourly = 'hourly',

  /**
   * Per day.
   */
  Daily = 'daily',

  /**
   * Per week.
   */
  Weekly = 'weekly',

  /**
   * Per month.
   */
  Monthly = 'monthly',

  /**
   * Per year.
   */
  Yearly = 'yearly',
}
